// Sets a query-string parameter on the current URL without navigating.
// Used by the paginationLayout renderer to keep `?page=N` shareable.
export const replaceSearchParam = (searchParam: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(searchParam, value);
  window.history.replaceState({}, '', url);
};
